const CONTENT_TYPE = {
  PARTICIPANT_JOINED: 'application/vnd.amazonaws.connect.event.participant.joined',
  CHAT_ENDED: 'application/vnd.amazonaws.connect.event.chat.ended'
};

const _appendToMessages = (container, messageHtml) => {
  const messages = container.querySelector('.aws-chatkit-messages');
  const div = document.createElement('div');
  div.innerHTML = messageHtml;
  messages.appendChild(div);
  messages.scrollTop = messages.scrollHeight;
};

export const appendEvent = (container, text) => {
  const messageHtml = `<div class="aws-chatkit-event">${text}</div>`;
  _appendToMessages(container, messageHtml);
};

export const appendMessage = (container, type, text, senderName) => {
  const messageHtml = `
    <div class="aws-chatkit-message ${type}">
      <div class="aws-chatkit-message-sender">${senderName}</div>
      <div>${text}</div>
    </div>
  `;
  _appendToMessages(container, messageHtml);
};

const _processAwsEvent = (container, content) => {
  if (content.ContentType === CONTENT_TYPE.PARTICIPANT_JOINED && content.ParticipantRole === 'CUSTOMER') {
    appendEvent(container, 'You have joined the chat');
  } else if (content.ContentType === CONTENT_TYPE.CHAT_ENDED) {
    appendEvent(container, 'The chat has ended');
  }
};

const _processAwsMessage = (container, content) => {
  const type = content.ParticipantRole === 'CUSTOMER' ? 'customer' : 'system';
  appendMessage(container, type, content.Content, content.DisplayName);
};

export const processWebsocketContent = (container, content) => {
  if (content.Type === 'EVENT') {
    _processAwsEvent(container, content);
  } else if (content.Type === 'MESSAGE') {
    _processAwsMessage(container, content);
  }
};
